import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { CommonUrlBasedService } from '../../../../services/common.url-based.service';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mec-step-exam-score-info',
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './step-exam-score-info.component.html',
  styleUrls: ['./step-exam-score-info.component.scss'],
})
export class StepExamScoreInfoComponent {
  @Input() public score: number;
  @Input() public hideAction: boolean = false;
  @Output() public actionClick = new EventEmitter<void>();

  public iconInfo = faCircleInfo;

  constructor(public _commonService: CommonUrlBasedService) {}

  public clickLink(): void {
    this.actionClick.emit();
  }
}
